import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProfilePicture } from '../../models/user/profile-picture.model';
import { environment } from '../../../../environments/environment';
import { User } from 'src/app/models/user';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly http = inject(HttpClient);

  // TODO check if this is needed in the future
  getUserProfilePicture(url: string): Observable<Blob> {
    return this.http.get<Blob>(url, { responseType: 'blob' as 'json' });
  }

  getProfilePicture(userId: string): Observable<ProfilePicture> {
    const url = `${environment.apiUrl}/picture`;

    return this.http.get<ProfilePicture>(url, { params: { userId } });
  }

  getUser(userId: string): Observable<User> {
    const apiUrl = `${environment.apiUrl}/patrons/${userId}`;
    return this.http.get<User>(apiUrl);
  }
}
